import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SkeletonCard from '../../../../../components/Skeleton/Card';

const Loading: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <Row>
        <Col>
          <SkeletonCard height={40} />
        </Col>
      </Row>
      <Row>
        <Col>
          <SkeletonCard height={120} />
        </Col>
      </Row>
    </>
  );
};

export default Loading;
